import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalSingleInput } from '@/lib/v2/organisms';

import { useActionsRules } from '@/src/modules/AutomationModuleNew/hooks/Rules/useActionsRules';
import { useRulesValidations } from '@/src/modules/AutomationModuleNew/hooks/useRulesValidations';

const TRANSLATE_MODAL = 'RECURRENT_MESSAGE.CREATE_RECURRENT';

type DuplicateRulesModalProps = {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  name: string;
  refetchData: () => void;
};

const DuplicateRulesModal = ({
  isOpen,
  onClose,
  id,
  refetchData,
  name,
}: DuplicateRulesModalProps) => {
  const { t } = useTranslation();
  const { VALIDATION_RULES } = useRulesValidations();
  const { duplicateRule, isLoading } = useActionsRules();

  const handleSubmitDuplicate = useCallback(
    async (name: string) => {
      const response = await duplicateRule(name, id);
      if (!response?.isValidInput) return response;
      onClose();
      refetchData();
    },
    [duplicateRule, id, onClose, refetchData]
  );

  return (
    <ModalSingleInput
      validateFieldsOnOpen
      alert={{
        description: t(`DuplicateJourneyMessageModal.alert`),
        type: 'info',
      }}
      disabled={isLoading}
      disabledSubmitButton={isLoading}
      id="duplicate-message-modal"
      isLoading={isLoading}
      isOpen={isOpen}
      rules={VALIDATION_RULES}
      title={t(`DuplicateRulesModal.title`)}
      value={`${name} ${t(`${TRANSLATE_MODAL}.copy`)}`}
      onClose={onClose}
      onSubmit={handleSubmitDuplicate}
    />
  );
};

export default memo(DuplicateRulesModal);
